var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAbc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_2570)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.301 0.298828C11.2746 0.298828 0.810547 10.7936 0.810547 23.814C0.810547 36.8344 11.2751 47.3291 24.301 47.3291C37.3262 47.3291 47.7821 36.8344 47.7821 23.814C47.7821 10.7936 37.3262 0.298828 24.301 0.298828Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.89874 16.4435C4.8128 16.4435 1.53442 19.7352 1.53442 23.8161C1.53442 27.8971 4.8128 31.1888 8.89874 31.1888C11.4077 31.1888 12.3885 29.4175 12.3885 29.4175V31.0289H16.2631V23.816C16.2631 19.735 12.9847 16.4434 8.89874 16.4434V16.4435ZM8.89874 20.2982C10.8468 20.2982 12.4083 21.8689 12.4083 23.8163C12.4083 25.7636 10.8468 27.3343 8.89874 27.3343C6.95072 27.3343 5.38915 25.7636 5.38915 23.8163C5.38915 21.8689 6.95072 20.2982 8.89874 20.2982Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.2002 11.3655V23.8153C17.2002 27.8963 20.481 31.1905 24.567 31.1905C28.6529 31.1905 31.9253 27.8962 31.9253 23.8153C31.9253 19.7343 28.6529 16.44 24.567 16.44C22.058 16.44 21.0738 18.2162 21.0738 18.2162V11.3652L17.2002 11.3655ZM24.567 20.297C26.515 20.297 28.077 21.8682 28.077 23.8155C28.077 25.7628 26.5151 27.334 24.567 27.334C22.619 27.334 21.0569 25.7628 21.0569 23.8155C21.0569 21.8682 22.619 20.297 24.567 20.297Z",
    fill: "#010314"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.9215 16.4435C35.8355 16.4435 32.5571 19.7352 32.5571 23.8161C32.5571 27.8971 35.8355 31.1888 39.9215 31.1888C43.4483 31.1888 46.3745 28.7361 47.109 25.4404H43.0355C42.4513 26.5643 41.281 27.3341 39.9215 27.3341C37.9734 27.3341 36.4119 25.7633 36.4119 23.816C36.4119 21.8687 37.9734 20.298 39.9215 20.298C41.2852 20.298 42.4614 21.0707 43.0439 22.2001H47.1089C46.3774 18.9003 43.4511 16.4434 39.9213 16.4434L39.9215 16.4435Z",
    fill: "#010314"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_2570"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.4413,
    height: 47.5,
    fill: "white",
    transform: "translate(0.558838)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAbc);
export default __webpack_public_path__ + "static/media/abc.af816133c40480d891e0a0360badb6a9.svg";
export { ForwardRef as ReactComponent };